export default { sha: '21a9f6577aec2ecbb81ee3a671da83700c42c9ad', buildNumber: 'undefined' }
